import React from 'react'
import { FetchProducts, ProductProps, checkedItems } from '../../types'
import ProductsDropDown from '../DropDowns/ProductsDropDown'
import { t } from 'i18next'


interface TableProps {
  checkedItems: checkedItems[],
  setCheckedItems: React.Dispatch<React.SetStateAction<checkedItems[]>>
  searchQuery: string,
  searchResult: ProductProps[] | undefined,
  allProducts?: FetchProducts
  setSelectedIdForDelete: React.Dispatch<React.SetStateAction<string>>
  setDeleteConfPopup: React.Dispatch<React.SetStateAction<boolean>>
  setFailMsg: React.Dispatch<React.SetStateAction<string>>
  direction: string
  startingIndex: number
  permissions: {
    create: boolean,
    edit: boolean,
    delete: boolean,
  }
}

const ProductsTable = ({ checkedItems, setCheckedItems, permissions, direction, searchQuery, searchResult, allProducts, setSelectedIdForDelete, setDeleteConfPopup, startingIndex }: TableProps) => {

  const handleCheckAll = () => {
    if (allProducts?.allProducts.length !== checkedItems.length) {
      allProducts !== undefined && setCheckedItems(allProducts?.allProducts.map(product => ({ id: product.id })))
    } else {
      setCheckedItems([])
    }
  };

  const handleCheck = (id: string) => {
    const isItemExist = checkedItems.some(item => item.id === id);

    if (isItemExist) {
      const newChckedItems = checkedItems.filter(item => item.id !== id);
      setCheckedItems(newChckedItems);
    } else {
      setCheckedItems([...checkedItems, { id: id }])
    }
  };

  return (
    <table className="w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th scope="col" className="py-3.5 px-4 text-sm text-left rtl:text-right text-gray-500">
            <div className='relative flex'>
              <input type="checkbox" checked={allProducts?.allProducts.length === checkedItems.length} onChange={handleCheckAll} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
              <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
          </th>

          <th scope="col" className="font-semibold py-3.5 px-4 text-sm text-left rtl:text-right text-gray-500">
            {t('product')}
          </th>

          <th scope="col" className="font-semibold px-12 py-3.5 text-sm text-left rtl:text-right text-gray-500">
            {t('name')}
          </th>

          <th scope="col" className="font-semibold px-4 py-3.5 text-sm text-left rtl:text-right text-gray-500">
            {t('quantity')}
          </th>

          <th scope="col" className="font-semibold px-4 py-3.5 text-sm text-left rtl:text-right text-gray-500">
            {t('price')}
          </th>

          <th scope="col" className="font-semibold px-4 py-3.5 text-sm text-left rtl:text-right text-gray-500">
            {t('active')}
          </th>

          {permissions.edit || permissions.delete ?
            <th scope="col" className="font-semibold px-4 py-3.5 text-sm text-left rtl:text-right text-gray-500">
              {t('option')}
            </th>
            :
            null
          }
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {/* 10 is how much items per page */}
        {searchQuery !== "" ?
          searchResult?.map(product => (
            <tr key={product.id}>
              <td className="px-4 py-4 text-sm font-medium">
                <div className='relative flex'>
                  <input type="checkbox" checked={checkedItems.some(checkedItem => checkedItem.id === product.id)} onChange={() => handleCheck(product.id)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                  <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </td>
              <td className="px-4 py-4 text-sm">
                <img className='object-cover w-14 h-14' src={`https://store-api.qafilaty.com/images/${product.imagesProduct[0]?.name}`} alt="" loading="lazy" />
              </td>
              <td className="px-12 py-4 text-sm">
                <p className="text-gray-500">{product.name}</p>
              </td>

              <td className="px-4 py-4 text-sm">
                <p className="text-gray-500">{product.quantity === 99999 ? "unlimited" : product.quantity}</p>
              </td>

              <td className="px-4 py-4 text-sm">
                ${product.price}
              </td>
              <td className="px-4 py-4 text-sm whitespace-nowrap">
                {product.posting ?
                  <div className="inline px-3 py-1 text-sm font-semibold rounded-full text-emerald-500 gap-x-2 bg-emerald-100/60">
                    {t('Active')}
                  </div> :
                  <div className="inline px-3 py-1 text-sm font-semibold text-red-500 rounded-full gap-x-2 bg-red-100/60">
                    {t('Not Active')}
                  </div>
                }
              </td>

              {permissions.edit || permissions.delete ?
                <td className="px-4 py-4 text-sm">
                  <ProductsDropDown permissions={permissions} direction={direction} id={product.id} setSelectedIdForDelete={setSelectedIdForDelete} setDeleteConfPopup={setDeleteConfPopup} />
                </td>
                :
                null
              }
            </tr>
          ))
          :
          allProducts?.allProducts.slice(startingIndex, startingIndex + 10).map(product => {
            return (
              <tr key={product.id}>
                <td className="px-4 py-4 text-sm font-medium">
                  <div className='relative flex'>
                    <input type="checkbox" checked={checkedItems.some(checkedItem => checkedItem.id === product.id)} onChange={() => handleCheck(product.id)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                    <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                </td>
                <td className="px-4 py-4 text-sm">
                  <img className='object-cover w-16 h-14' src={`https://store-api.qafilaty.com/images/${product.imagesProduct[0]?.name}`} alt="" />
                </td>
                <td className="px-12 py-4 text-sm">
                  <p className="text-gray-500">{product.name}</p>
                </td>

                <td className="px-4 py-4 text-sm">
                  <p className="text-gray-500">{product.quantity === 99999 ? "unlimited" : product.quantity}</p>
                </td>

                <td className="px-4 py-4 text-sm">
                  ${product.price}
                </td>
                <td className="px-4 py-4 text-sm whitespace-nowrap">
                  {product.posting ?
                    <div className="inline px-3 py-1 text-sm font-semibold rounded-full text-emerald-500 gap-x-2 bg-emerald-100/60">
                      {t('Active')}
                    </div> :
                    <div className="inline px-3 py-1 text-sm font-semibold text-red-500 rounded-full gap-x-2 bg-red-100/60">
                      {t('Not Active')}
                    </div>
                  }
                </td>

                {permissions.edit || permissions.delete ?
                  <td className="px-4 py-4 text-sm">
                    <ProductsDropDown permissions={permissions} direction={direction} id={product.id} setSelectedIdForDelete={setSelectedIdForDelete} setDeleteConfPopup={setDeleteConfPopup} />
                  </td>
                  :
                  null
                }
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default ProductsTable